import React from "react";

const PitchesIcon = ({ className }: { className?: string }) => {
  return (
    <>
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <path
          d="M13.7639 1.61982C15.1875 1.31008 16.5337 0.702523 17.9931 0.5C18.0646 0.851437 17.8561 1.01821 17.7429 1.21478C16.7601 2.90048 15.7832 4.58618 14.7765 6.25402C14.4787 6.74246 14.4191 7.25473 14.3477 7.80869C14.1034 9.71479 14.6395 11.4005 15.6402 13.0028C16.3312 14.1107 16.9209 15.2782 17.5583 16.4219C17.731 16.7316 17.9037 17.0413 17.9335 17.5C17.0162 17.2022 16.1346 16.8984 15.2471 16.6363C10.8095 15.314 6.37184 14.0035 1.93421 12.6811C-0.0612416 12.0855 0.0995872 12.1748 0.0281085 10.2151C0.0161954 9.92923 0.00428372 9.6433 -0.00762939 9.36334C0.00428372 8.88682 0.0221487 8.4103 0.0340618 7.93377C0.117454 7.45725 0.200844 6.98073 0.284236 6.5042C0.355715 5.89068 0.748848 5.64646 1.30876 5.5035C2.08907 5.30694 2.84555 5.02697 3.61395 4.78275C5.30561 4.33601 6.97345 3.81184 8.61746 3.21619C10.3508 2.75158 12.0604 2.20357 13.7639 1.62578V1.61982Z"
          fill="white"
        />
      </svg>
    </>
  );
};

export default PitchesIcon;
